import type { Address } from "viem"
import type { Config } from "wagmi"

import type { EmitEvent } from "@/domains/core"
import type { IEventBus } from "@/domains/events"
import { EventEmitter } from "@/domains/library"
import { delegateSuperVoterManager } from "@/domains/on-chain"
import { SuperVoterManagerDelegatedEvent } from "@/domains/vote-page/events"

interface DelegateVotesParams {
  account: Address
  chainId: number
  config: Config
  superVoterAddress: Address
  managerAddress: Address
  emitter: EventEmitter<EmitEvent>
  eventBus: IEventBus
}

export const delegateSuperVoterManagerInteraction = async ({
  account,
  chainId,
  config,
  superVoterAddress,
  managerAddress,
  emitter,
  eventBus,
}: DelegateVotesParams) => {
  const result = await delegateSuperVoterManager({
    account,
    chainId,
    config,
    superVoterAddress,
    managerAddress,
  })

  if (result.success) {
    // Emit domain event for orchestrator to refresh access state
    eventBus.publish(new SuperVoterManagerDelegatedEvent(account, managerAddress, result.tx))
    // Emit user notification
    emitter.emit("delegate-super-voter-manager", {
      title: "SuperVoter Manager delegated",
      description: `SuperVoter Manager delegated to ${managerAddress}`,
      variant: "success",
    })
  }

  if (result.success === false) {
    emitter.emit("error-delegating-super-voter-manager", {
      title: "SuperVoter Manager delegation failed",
      description: `Unable to delegate SuperVoter Manager to ${managerAddress}, reason ${result.error}`,
      variant: "error",
    })
  }

  return result
}
